export default {
  SET_ERRORS: (state, errors) => (state.errors = errors),
  SET_SUCCESS: (state, success) => (state.success = success),
  SET_COOPS: (state, coops) => (state.coops = coops),
  SET_NEXT_COOPS_URL: (state, next_coops_url) =>
    (state.next_coops_url = next_coops_url),
  SET_SEARCH_KEYWORD: (state, search_keyword) =>
    (state.search_keyword = search_keyword),
  SET_SEARCH_STATION: (state, search_station) =>
    (state.search_station = search_station),
};
